import { render, staticRenderFns } from "./ButtonBack.vue?vue&type=template&id=cc12ea90"
import script from "./ButtonBack.vue?vue&type=script&lang=js"
export * from "./ButtonBack.vue?vue&type=script&lang=js"
import style0 from "./ButtonBack.vue?vue&type=style&index=0&id=cc12ea90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports